var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUiwMailO2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 72,
    viewBox: "0 0 94 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1389_3888)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7486 5.875C83.7505 5.875 87 9.1201 87 13.1264V63.8736C87 67.8755 83.7549 71.125 79.7486 71.125H7.25145C3.24945 71.125 0 67.8799 0 63.8736V13.1264C0 9.12445 3.2451 5.875 7.25145 5.875H79.7486ZM31.1808 44.2768L9.8223 65.383H76.486L55.3581 44.4943L43.5 52.7028L31.1808 44.2768ZM81.084 26.7202L60.2214 41.1448L81.084 61.7464V26.7202ZM5.92035 26.9855V61.0722L26.3044 40.9273L5.92035 26.9855ZM79.6789 11.6214H7.3863C6.98947 11.6036 6.60073 11.7373 6.2988 11.9955C6.16483 12.1154 6.0614 12.2656 5.9971 12.4336C5.93279 12.6015 5.90946 12.7824 5.92905 12.9612V20.0082L43.5 45.7036L81.1014 19.7558V13.2656C81.1043 12.6856 80.9709 12.2622 80.7012 11.9955C80.5683 11.8638 80.4086 11.7622 80.2329 11.6977C80.0573 11.6331 79.8699 11.6071 79.6833 11.6214",
    fill: "#348BDC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 9.5,
    r: 9.5,
    fill: "#02BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.432 6.9875V5.4395H85.324V14.1875H83.596V6.9875H82.432Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1389_3888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiwMailO2);
export default __webpack_public_path__ + "static/media/uiw_mail-o (2).f62d08a579ef8911fd87108aaa3342e6.svg";
export { ForwardRef as ReactComponent };